import type { DeviceType } from "~/src/api";

export const INDEX_DEVICE_TYPE: DeviceType = "web";
